module.exports = __webpack_public_path__ + "img/icon_coppie.ffb60e5c.svg";